import React, { UIEventHandler, useState } from 'react'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ArticleItem } from './ArticleItem'
import { GoTo } from 'ui/inputs/GoTo'
import { EmptyState } from './EmptyState'
import { DataWrapper } from 'components/patterns/suspense/internals/types'
import { FavoriteIcon } from 'components/patterns/icons'
import { buildArticleSummaryDataWrapper } from 'services/ContentfulService/hooks/articles'
import { BlockComponent, truncArray } from 'lib'
import { ArticlesMobileDots, ArticlesWrapper, Bottom, Dot, Title, TitleWrapper, Wrapper } from './styles'
import { generateComponents } from 'components/patterns/Skeleton'
import { scrolledToIndex } from '../../lib/scrolledToIndex'
import { Favorite } from 'generated/api'

interface Props {
	articles: Array<DataWrapper<ArticleSummary>>
}

interface DotProps {
	total: number
	current: number
}
const Dots: BlockComponent<DotProps> = ({ total, current }) => {
	return generateComponents(key => <Dot key={key} isActive={key === current} />, total)
}

const HorizontalScroller: BlockComponent<Props> = ({ articles }) => {
	const [index, setIndex] = useState(0)

	const onScroll: UIEventHandler<HTMLElement> = event =>
		requestAnimationFrame(() => {
			setIndex(scrolledToIndex(event.target as HTMLElement))
		})

	return (
		<>
			<ArticlesWrapper onScroll={onScroll}>
				{articles.map(articleWrapper => (
					<ArticleItem key={articleWrapper.getId()} data={articleWrapper} />
				))}
			</ArticlesWrapper>
			<ArticlesMobileDots>
				<Dots total={articles.length} current={index} />
			</ArticlesMobileDots>
		</>
	)
}

const ArticleListView: BlockComponent<Props> = ({ articles }) => {
	return (
		<Wrapper>
			<TitleWrapper>
				<FavoriteIcon color="#FFCA28" outline="#FFCA28" />
				<Title>Your favorite articles</Title>
			</TitleWrapper>
			<HorizontalScroller articles={articles} />
			<Bottom>
				<GoTo direction="none" href="/learn/reading-list">
					My Reading List
				</GoTo>
			</Bottom>
		</Wrapper>
	)
}

const MAX_ARTICLES = 3

export const FavoriteArticlesCardView = ({ favorites }: { favorites: DataWrapper<Array<Favorite>> }) => {
	const data = favorites.read()
	const articles = truncArray(data, MAX_ARTICLES).map(favorite => buildArticleSummaryDataWrapper(favorite.favoriteId))
	if (articles.length === 0) return <EmptyState />
	return <ArticleListView articles={articles} />
}
